import React from "react";
import { Count } from "./Styled";
import { Tag } from "antd";

type ItemProps = {
  title: string;
  sentenceCount: number;
};

const Item: React.FunctionComponent<ItemProps> = ({ title, sentenceCount }) => {
  return (
     <><span>{title}</span><Count><Tag color="blue">{sentenceCount}</Tag></Count></>
  );
};

export default Item;
